import React, { useReducer } from "react";
import axios from "axios";
import AdminLeloContext from "./adminLeloContext";
import AdminLeloReducer from "./adminLeloReducer";
import setAuthToken from "../../functions/auth_header";
import ErrorLogger from "../../components/ErrorLogger";


import {
  GET_LELOENTRIES,
  GET_LELOENTRIE,
  UPDATE_LELOENTRIE,
  FILTER_TABLE,
  SEARCH_FILTER,
  CLEAR_SEARCH_FILTER,
  CLEAR_FILTER_TABLE,
  CLEAR_LELOENTRIE,
  INACTIVE_FILTER,
  CLEAR_INACTIVE_FILTER,
  SESSION_FILTER,
  CLEAR_SESSION_FILTER,
  ACTIVE_FILTER,
  SIGNED_FILTER,
  FILTER_BY_DATE,
  CLEAR_DATE_FILTER,
  GET_LELO_SESSION,
  SET_LOADING,
  GET_LELOENTRIES_OPTIMIZED,
  SET_LOADING_OPTIMIZED,
  GET_LELOENTRIES_OPTIMIZED_ZIP,
  SET_LIST_VIEW,
} from "../types";

import { getAppUrl } from "../../functions/getEnv";

const AdminLeloState = (props) => {
  const initialState = {
    formData: {

    },
    firstName: "",
    Leloentries: [],
    LeloentriesOptimized: [],
    LeloentriesOptimizedzip: [],
    Leloentrie: {},
    filteredEntries: [],
    DateFiltered: [],
    activeEntries: [],
    signedEntries: [],
    searchFiltered: [],
    InactiveFiltered: [],
    ActiveFiltered: [],
    SignedFiltered: [],
    SessionEntries: [],
    leloSession: [],
    LeloListStatus: {
      inactive: false,
      active: false,
      signed: false,
    },

    sortOptions: {
      createdAt: { asc: false, desc: true },
      status: { asc: false, desc: false },
      firstName: { asc: false, desc: false },
      lastName: { asc: false, desc: false },
      studentEmail: { asc: false, desc: false },
      studentPrimaryPhone: { asc: false, desc: false },
      learningCenters: { asc: false, desc: false },
      uploadedUrl: { asc: false, desc: false },
      permaLink: { asc: false, desc: false },
    },
    searchText: "",
    setSession: "",
    startDate: null,
    endDate: null,
    loading: true,
    error: null,
    currentPage: 1,
    pageSize: 300, // You can adjust this default value as needed
    totalCount: 0,
    visibleColumns: {
      createdAt: true,
      status: true,
      firstName: true,
      learningCenters: true,
      studentPrimaryPhone: true,
      studentEmail: true,
      uploadedUrl: true,
      permaLink: true,
    },
    listView: true,
  };


  const [state, dispatch] = useReducer(AdminLeloReducer, initialState);

  /* const apiUrl =
      import.meta.env.MODE === `production` ? `` : `http://localhost:5000`; */

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);


  // const getLeloEntries = async () => {
  //   try {
  //     if (localStorage.token) {
  //       setAuthToken(localStorage.token);
  //     }

  //     // Fetch all data
  //     const response = await axios.get(`${appUrl}/api/leloRegistration`);
  //     console.log("Data retrieved successfully:", response.data.data);
  //     // Dispatch the filtered data
  //     dispatch({ type: GET_LELOENTRIES, payload: response.data.data });
  //   } catch (error) {
  //     //console.error("Error fetching Lelo entries:", error.message);
  //     ErrorLogger.logError(error.message);
  //   }
  // };

  // const getLeloEntries = async ({ status, permaLink, page = 1, pageSize = 300, search } = {}) => {
  //   try {
  //     if (localStorage.token) {
  //       setAuthToken(localStorage.token);
  //     }
  //     dispatch({ type: SET_LOADING });
  //     const params = new URLSearchParams();
  //     if (status) params.append("status", status);
  //     if (permaLink) params.append("permaLink", permaLink);
  //     if (search) params.append("search", search);
  //     params.append("page", page);
  //     params.append("pageSize", pageSize);

  //     // Perform GET request
  //     const response = await axios.get(`${appUrl}/api/leloRegistration?${params.toString()}`);
  //     //console.log("Data retrieved successfully:", response.data.data);
  //     dispatch({
  //       type: GET_LELOENTRIES,
  //       payload: response.data.data,
  //       totalCount: response.data.total_count,
  //       status,
  //       permaLink,
  //       page,
  //       pageSize,
  //       search,
  //     });
  //   } catch (error) {
  //     ErrorLogger.logError(error.message);
  //   }
  // };
  const getLeloEntries = async ({
    status,
    permaLink,
    page = 1,
    pageSize = 300,
    searchText,
    startDate,
    endDate,
    learningCenterId,
    learningCenterCharter
  } = {}) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      dispatch({ type: SET_LOADING });
      console.log("filters",learningCenterId )


      const params = new URLSearchParams();

      // Existing filters
      if (status) params.append("status", status);
      if (permaLink) params.append("permaLink", permaLink);
      if (searchText) params.append("search", searchText);

      // Learning Center filters
      if (learningCenterId) params.append("learningCenterId", learningCenterId);
      if (learningCenterCharter) params.append("learningCenterCharter", learningCenterCharter);

      // Date range filters
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      // Pagination
      params.append("page", page);
      params.append("pageSize", pageSize);
      
      // Perform GET request
      const response = await axios.get(`${appUrl}/api/leloRegistration?${params.toString()}`);

      //console.log("Data retrieved successfully:", response.data.data);

      //console.log("Applied filters:", response.data.applied_filters);
      dispatch({
        type: GET_LELOENTRIES,
        payload: response.data.data,
        totalCount: response.data.total_count,
        appliedFilters: response.data.applied_filters,
        status,
        permaLink,
        page,
        pageSize,
        searchText,
        startDate,
        endDate,
      });
    } catch (error) {
      ErrorLogger.logError(error.message);
    }
  };

  const getLeloEntriesOptimize = async ({
    status,
    permaLink,
    searchText,
    startDate,
    endDate
  } = {}) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      dispatch({ type: SET_LOADING_OPTIMIZED });

      const params = new URLSearchParams();
      if (status) params.append("status", status);
      if (permaLink) params.append("permaLink", permaLink);
      if (searchText) params.append("search", searchText);

      // Date range filters
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const response = await axios.get(`${appUrl}/api/optimizeLeloAPI?${params.toString()}`);

      dispatch({
        type: GET_LELOENTRIES_OPTIMIZED,
        payload: response.data.data, // only filtered data is sent
        status,
        permaLink,
        searchText,
        startDate,
        endDate
      });
      return response.data.data;
    } catch (error) {
      ErrorLogger.logError(error.message);
    }
  };

  const getLeloEntriesOptimizezip = async ({
    status,
    permaLink,
    searchText,
    startDate,
    endDate
  } = {}) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      //console.log("getLeloEntriesOptimize called with params:", { status, permaLink });
      dispatch({ type: SET_LOADING_OPTIMIZED });

      const params = new URLSearchParams();
      if (status) params.append("status", status);
      if (permaLink) params.append("permaLink", permaLink);
      if (searchText) params.append("search", searchText);

      // Date range filters
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const response = await axios.get(`${appUrl}/api/optimizeLeloAPI/zip?${params.toString()}`);
      //console.log("Data retrieved successfully:", response.data.data);
      dispatch({
        type: GET_LELOENTRIES_OPTIMIZED_ZIP,
        payload: response.data.data, // only filtered data is sent
        status,
        permaLink,
        searchText,
        startDate,
        endDate
      });
      return response.data.data;
    } catch (error) {
      ErrorLogger.logError(error.message);
    }
  };

  const setCurrentPage = (page) => {
    dispatch({ type: "SET_CURRENT_PAGE", payload: page });
  };

  const setIsSearchActive = (search) => {
    dispatch({ type: "SET_IS_SEARCH_ACTIVE", payload: search });
  };

  const setIsSession = (session) => {
    dispatch({ type: "SET_SESSION", payload: session });
  };

  const setStartDate1 = (startDate) => {
    dispatch({ type: "SET_START_DATE", payload: startDate });
  };
  const setEndDate1 = (endDate) => {
    dispatch({ type: "SET_END_DATE", payload: endDate });
  };

  const toggleColumn = (columnName) => {
    dispatch({ type: "TOGGLE_COLUMN", payload: columnName });
  };

  const getLeloEntrie = async (id) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.get(`${appUrl}/api/leloRegistration/${id}`);
      dispatch({ type: GET_LELOENTRIE, payload: res.data });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const updateLeloEntrie = async (id, data) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.put(
        `${appUrl}/api/leloRegistration/${id}`, data
      );
      dispatch({ type: UPDATE_LELOENTRIE, payload: res.data });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearLeloEntrie = async () => {
    try {
      dispatch({ type: CLEAR_LELOENTRIE });
    } catch (error) {
      // console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const onTableFilter = (value) => {
    try {
      dispatch({ type: FILTER_TABLE, payload: value });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearTableFilter = () => {
    try {
      dispatch({ type: CLEAR_FILTER_TABLE });
    } catch (error) {
      // console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const searchFilter = async (text) => {
    try {
      dispatch({ type: SEARCH_FILTER, payload: text });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearSearchFilter = () => {
    try {
      dispatch({ type: CLEAR_SEARCH_FILTER });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const sessionFilter = (permaLink) => {
    try {
      dispatch({ type: SESSION_FILTER, payload: permaLink });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearSessionFilter = () => {
    try {
      dispatch({ type: CLEAR_SESSION_FILTER });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const getLeloSession = async (sesson_id) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const response = await axios.get(`${appUrl}/api/sessions/${sesson_id}`, {
        params: {
          LeloRegistrationProfile: sesson_id,
        },
      });
      //console.log("Data retrieved successfully course:", response.data);
      dispatch({
        type: GET_LELO_SESSION,
        payload: { data: response.data },
      });

    } catch (error) {
      // console.error("Error retrieving sessions:", error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const InactiveFilter = async (type) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      dispatch({ type: INACTIVE_FILTER, payload: type });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const ActiveFilter = async (type) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      dispatch({ type: ACTIVE_FILTER, payload: type });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const SignedFilter = async (type) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      dispatch({ type: SIGNED_FILTER, payload: type });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };


  const setDateRangeFilter = async (startDate, endDate) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      if (!startDate || !endDate) {
        console.warn("No date range provided.");
        return;
      }

      // Convert dates to start and end of day to ensure complete coverage
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);

      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);

      // Filter the entries based on date range
      const filteredEntries = state.Leloentries.filter((entry) => {
        const entryDate = new Date(entry.createdAt);
        return entryDate >= start && entryDate <= end;
      });

      dispatch({
        type: FILTER_BY_DATE,
        payload: {
          startDate: start,
          endDate: end,
          filteredEntries,
        },
      });
    } catch (error) {
      //console.error("Error filtering by date:", error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearDateFilter = () => {
    try {
      dispatch({ type: CLEAR_DATE_FILTER });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  }

  const clearInactiveFilter = () => {
    try {
      dispatch({ type: CLEAR_INACTIVE_FILTER });
    } catch (error) {
      //console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const setListView = (value) => {
    try {
      dispatch({ type: SET_LIST_VIEW, payload: value });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  return (
    <AdminLeloContext.Provider
      value={{
        Leloentries: state.Leloentries,
        Leloentrie: state.Leloentrie,
        sortOptions: state.sortOptions,
        filteredEntries: state.filteredEntries,
        signedEntries: state.signedEntries,
        activeEntries: state.activeEntries,
        SessionEntries: state.SessionEntries,
        searchFiltered: state.searchFiltered,
        InactiveFiltered: state.InactiveFiltered,
        SignedFiltered: state.SignedFiltered,
        ActiveFiltered: state.ActiveFiltered,
        LeloListStatus: state.LeloListStatus,
        DateFiltered: state.DateFiltered,
        leloSession: state.leloSession,
        loading: state.loading,
        currentPage: state.currentPage,
        pageSize: state.pageSize,
        totalCount: state.totalCount,
        LeloentriesOptimized: state.LeloentriesOptimized,
        loadingOpt: state.loadingOpt,
        searchText: state.searchText,
        setSession: state.setSession,
        LeloentriesOptimizedzip: state.LeloentriesOptimizedzip,
        appliedFilters: state.appliedFilters,
        startDate: state.startDate,
        endDate: state.endDate,
        visibleColumns: state.visibleColumns,
        listView: state.listView,
        getLeloEntries,
        getLeloEntrie,
        onTableFilter,
        clearTableFilter,
        searchFilter,
        clearSearchFilter,
        updateLeloEntrie,
        clearLeloEntrie,
        InactiveFilter,
        clearInactiveFilter,
        getLeloSession,
        sessionFilter,
        clearSessionFilter,
        ActiveFilter,
        SignedFilter,
        setDateRangeFilter,
        clearDateFilter,
        setCurrentPage,
        getLeloEntriesOptimize,
        setIsSearchActive,
        setIsSession,
        getLeloEntriesOptimizezip,
        setStartDate1,
        setEndDate1,
        toggleColumn,
        setListView,
      }}
    >
      {props.children}
    </AdminLeloContext.Provider>
  );
};

export default AdminLeloState;

